import { Link } from 'react-router-dom'

import { FxButton, FxIcon, FxPanel } from '@/components/fx'
import type { Template } from '@/types/domain'

import { documentCountLabel, formatDate } from './projectData'

/**
 * "Ohne Projekt": the forms that are in no project the caller can see.
 *
 * That includes a form filed in a project shared with someone else and not
 * with this account — its `folder` names a folder that is not in the list.
 * Showing it here is the lesser wrong: the alternative is a form that exists,
 * is listed nowhere, and cannot be found at all.
 */
export function UnfiledPanel({
  templates,
  onMove,
}: {
  templates: Template[]
  onMove: (template: Template) => void
}) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="m-0 text-tile-title">Ohne Projekt</h2>
      <FxPanel className="px-6 py-2">
        <ul className="m-0 flex list-none flex-col p-0">
          {templates.map((template, index) => (
            <li
              key={template.id}
              className={
                'flex flex-wrap items-center gap-3 py-3' +
                (index < templates.length - 1 ? ' border-b-2 border-divider' : '')
              }
            >
              <FxIcon name="description" size={22} className="flex-none text-primary" />
              <Link
                to={`/templates/${template.id}`}
                className="min-w-0 flex-1 truncate text-body text-text no-underline hover:text-primary-text hover:underline"
              >
                {template.title}
              </Link>
              <span className="hidden w-[140px] flex-none text-small text-text-muted sm:block">
                {documentCountLabel(template.documentCount ?? 0)}
              </span>
              <span className="hidden w-[110px] flex-none text-right text-small tabular-nums text-text-muted xs:block">
                {formatDate(template.updatedAt)}
              </span>
              <FxButton
                variant="tonal"
                icon="drive_file_move"
                className="h-9"
                onClick={() => onMove(template)}
              >
                In Projekt verschieben
              </FxButton>
            </li>
          ))}
        </ul>
      </FxPanel>
    </section>
  )
}
